import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";

const AlertManagementTable = ({ loading, consentData }) => {
  const columns = [
    { id: "sno", label: "S.No" },
    { id: "id", label: "ID" },
    { id: "username", label: "Username" },
    { id: "phoneno", label: "Phone" },
    { id: "email", label: "Email" },
    { id: "consent_status", label: "Consent_Status" },
    { id: "date_joined", label: "Date Joined" },
    { id: "expiry_date", label: "Expiry Date" },
    { id: "referralcode", label: "Referral Code" },
  ];

  return (
    <Box
      sx={{
        background: "#ffffff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
        overflow: "hidden",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          overflow: "auto",
          boxShadow: "none",
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          overflowY: "auto",
          maxHeight: "65vh",
          border: "1px solid #e2e8f0",
          borderRadius: "8px",
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.id}
                  sx={{
                    fontWeight: 700,
                    fontSize: "11px",
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid rgba(255,255,255,0.1)",
                    backgroundColor: "#04343a",
                    color: "#ffffff",
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={22} sx={{ color: "#016551" }} />
                    <Typography variant="body2" sx={{ color: "#016551" }}>Loading...</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : consentData && consentData.length > 0 ? (
              consentData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:nth-of-type(even)": { backgroundColor: "#f8fafc" }, "&:hover": { backgroundColor: "#eef2f7" } }}
                >
                  {columns.map((col) => (
                    <TableCell
                      key={col.id}
                      sx={{
                        padding: "6px 10px",
                        fontSize: "12px",
                        textAlign: col.id === "sno" ? "center" : "left",
                        borderRight: "1px solid #f0f0f0",
                        whiteSpace: "nowrap",
                        color: "#374151",
                      }}
                    >
                      {col.id === "sno"
                        ? index + 1
                        : col.id === "expiry_date"
                        ? row?.user_subscription?.expiry_date ?? "-"
                        : row[col.id] ?? "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center" sx={{ py: 3, color: "#6b7280", fontSize: 13 }}>
                  No Data Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AlertManagementTable;
